(() => {
  class EurolinkCollectionFaq extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.load();
    }

    async load() {
      try {
        const source = this.dataset.source || '';
        const currentHandle = this.dataset.collectionHandle || '';

        if (!source || !currentHandle) {
          this.remove();
          return;
        }

        const response = await fetch(source, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`FAQ request failed with ${response.status}`);

        const payload = await response.json();
        const categories = payload && typeof payload.categories === 'object' ? payload.categories : {};

        const ownCategory = this.validCategory(categories[currentHandle]);
        const groups = ownCategory
          ? [ownCategory]
          : this.childHandles()
              .map((handle) => this.validCategory(categories[handle]))
              .filter(Boolean);

        if (groups.length === 0) {
          this.remove();
          return;
        }

        this.render(groups, Boolean(ownCategory));
        this.bindAccordion();
        this.hidden = false;
      } catch (error) {
        console.warn('[Eurolink FAQ]', error);
        this.remove();
      }
    }

    validCategory(category) {
      if (!category || !Array.isArray(category.items)) return null;

      const items = category.items.filter(
        (item) => item && typeof item.question === 'string' && typeof item.answer === 'string'
      );

      if (items.length === 0) return null;

      return {
        title: typeof category.title === 'string' ? category.title : '',
        url: typeof category.url === 'string' && category.url.startsWith('/collections/') ? category.url : '',
        items,
      };
    }

    childHandles() {
      const node = this.querySelector('[data-faq-child-handles]');
      if (!node) return [];

      try {
        const handles = JSON.parse(node.textContent || '[]');
        return Array.isArray(handles)
          ? [...new Set(handles.filter((handle) => typeof handle === 'string' && handle !== ''))]
          : [];
      } catch {
        return [];
      }
    }

    render(groups, isLevelTwo) {
      const target = this.querySelector('[data-faq-content]');
      if (!target) return;

      target.innerHTML = '';
      this.classList.toggle('eurolink-faq--single', isLevelTwo);

      const header = document.createElement('div');
      header.className = 'eurolink-faq__header';

      const heading = document.createElement('h2');
      heading.className = 'eurolink-faq__heading';
      heading.textContent = isLevelTwo && groups[0].title
        ? `Česta pitanja: ${groups[0].title}`
        : 'Česta pitanja po kategorijama';

      header.append(heading);
      target.appendChild(header);

      const groupList = document.createElement('div');
      groupList.className = 'eurolink-faq__groups eurolink-faq__list';

      let faqIndex = 0;

      groups.forEach((group) => {
        const groupElement = document.createElement('section');
        groupElement.className = 'eurolink-faq__group';

        if (!isLevelTwo && group.title) {
          const groupHeading = document.createElement('h3');
          groupHeading.className = 'eurolink-faq__group-heading';

          if (group.url) {
            const link = document.createElement('a');
            link.href = group.url;
            link.textContent = group.title;
            groupHeading.appendChild(link);
          } else {
            groupHeading.textContent = group.title;
          }

          groupElement.appendChild(groupHeading);
        }

        group.items.forEach((item) => {
          const itemElement = document.createElement('div');
          itemElement.className = 'eurolink-faq__item';

          const button = document.createElement('button');
          button.className = 'eurolink-faq__question';
          button.type = 'button';
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', `eurolink-faq-answer-${faqIndex}`);

          const questionText = document.createElement('span');
          questionText.className = 'eurolink-faq__question-text';
          questionText.textContent = item.question;

          const icon = document.createElement('span');
          icon.className = 'eurolink-faq__icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.textContent = '⌄';

          button.append(questionText, icon);

          const answerWrap = document.createElement('div');
          answerWrap.id = `eurolink-faq-answer-${faqIndex}`;
          answerWrap.className = 'eurolink-faq__answer-wrap';

          const answer = document.createElement('div');
          answer.className = 'eurolink-faq__answer rte';
          answer.textContent = item.answer;

          answerWrap.appendChild(answer);
          itemElement.append(button, answerWrap);
          groupElement.appendChild(itemElement);

          faqIndex += 1;
        });

        groupList.appendChild(groupElement);
      });

      target.appendChild(groupList);
    }

    bindAccordion() {
      const buttons = this.querySelectorAll('.eurolink-faq__question');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('.eurolink-faq__item');
          const answer = item.querySelector('.eurolink-faq__answer-wrap');
          const isOpen = item.classList.contains('is-open');

          this.querySelectorAll('.eurolink-faq__item').forEach((otherItem) => {
            const otherButton = otherItem.querySelector('.eurolink-faq__question');
            const otherAnswer = otherItem.querySelector('.eurolink-faq__answer-wrap');

            otherItem.classList.remove('is-open');
            otherButton.setAttribute('aria-expanded', 'false');
            otherAnswer.style.maxHeight = null;
          });

          if (!isOpen) {
            item.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        });
      });
    }
  }

  if (!customElements.get('eurolink-collection-faq')) {
    customElements.define('eurolink-collection-faq', EurolinkCollectionFaq);
  }
})();